import React from 'react'
import { PlanDetailsRow } from '.'
import { InnerTableHeader } from './styles'
import { EmployeePlanInfo } from '../../../interfaces/employee'

export const CollapsibleTableRow: React.FC<{ data?: EmployeePlanInfo }> = ({
  data
}) => {
  return (
    <tr className="collapse" style={{ background: '#F8F9FA' }}>
      <td colSpan={6}>
        <table className="w-100">
          <thead className="bg-light">
            <InnerTableHeader />
            <InnerTableHeader className="text-left">Plan</InnerTableHeader>
            <InnerTableHeader />
            <InnerTableHeader>Employer Cost</InnerTableHeader>
            <InnerTableHeader>Employee Cost</InnerTableHeader>
            <InnerTableHeader>Total Cost</InnerTableHeader>
          </thead>
          <tbody>
            {data?.plans?.map((plan: any) => {
              return <PlanDetailsRow plan={plan} />
            })}
          </tbody>
        </table>
      </td>
    </tr>
  )
}
